import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { Home } from './pages/Home';
import { PatientCreation } from './pages/PatientCreation';
import { PatientHistory } from './pages/PatientHistory';
import { ClinicalChart } from './pages/ClinicalChart';
import { CommercialHandoff } from './pages/CommercialHandoff';
import { LensTryOn } from './pages/LensTryOn';
import { Reports } from './pages/Reports';
import { ImportPatients } from './pages/ImportPatients';
import { Settings } from './pages/Settings';
import { WhatsAppInbox } from './pages/WhatsAppInbox';
import { WhatsAppSettings } from './pages/WhatsAppSettings';
import { WhatsAppProvider } from './whatsapp/WhatsAppContext';
import { InboxProvider } from './whatsapp/InboxProvider';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <WhatsAppProvider>
        <InboxProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/home" element={<Home />} />
            <Route path="/patient" element={<PatientCreation />} />
            <Route path="/patient/:patient_id" element={<PatientCreation />} />
            <Route path="/clinical-chart/:patient_id/new" element={<ClinicalChart />} />
            <Route path="/clinical-chart/:patient_id/:visit_id" element={<ClinicalChart />} />
            <Route path="/history/:patient_id" element={<PatientHistory />} />
            <Route path="/commercial-handoff/:visit_id" element={<CommercialHandoff />} />
            <Route path="/commercial-handoff/:visit_id/try-on" element={<LensTryOn />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/import-patients" element={<ImportPatients />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/whatsapp" element={<WhatsAppInbox />} />
            <Route path="/whatsapp/settings" element={<WhatsAppSettings tab="whatsapp" />} />
            <Route path="/whatsapp/settings/assistant" element={<WhatsAppSettings tab="assistant" />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </InboxProvider>
      </WhatsAppProvider>
    </BrowserRouter>
  );
}

export default App;

